import React from "react";

// variant: "emblem" (circle mark only) | "full" (complete logo image)
export const Logo = ({ variant = "emblem", size = "md", onClick, className = "" }) => {
  const emblemH = size === "lg" ? "h-12" : "h-10";
  const fullH = size === "lg" ? "h-24" : "h-16";
  const src = variant === "full" ? "/amt-logo-dark.png" : "/amt-emblem.png";
  return (
    <img
      data-testid="amt-logo"
      src={src}
      alt="amt consulting"
      onClick={onClick}
      className={`${variant === "full" ? fullH : emblemH} w-auto ${onClick ? "cursor-pointer" : ""} ${className}`}
    />
  );
};
